// TOGGLE START   #############################
$("#show-footer").click(function() {
  $(this).text(function(i, v) { return v == "Hide Footer Links" ? "View Footer Links" : "Hide Footer Links"; });
  $(".footer-links").toggle(400);
});
// TOGGLE END   #############################

// MENUS START   ############################
$(function() {
  
 	// NAV START   ########################## 
	$('#NavDrawer').mmenu({
		extensions	: [ 'listview-large'],
			iconPanels 	: true,
			offCanvas: { 
              	zposition : 'front'
          	},
      	setSelected: {
            parent: true
         },
      
      	
				
					
			navbar 	: {
				title : 'Menu'
			},
			navbars	:[
              
              	{
					position	: 'top',
                  content		: [ "<div style='max-width:90px; margin:auto;'><img src='//cdn.shopify.com/s/files/1/0267/6713/t/10/assets/nav-logo.png?v=57058258622477761711492093417' alt=''></div>" ]
			},
              
              {
					position	: 'top',
					content		: [ 'breadcrumbs', 'close' ]
					}, 
                      
                    {
					position	: 'bottom',
					content		: [ "<a class='fa fa-envelope' href='mailto:sales@worldabs.com'></a>"
                  , "<a class='fa fa-twitter' href='https://twitter.com/worldabs' target='_blank'></a>"
                  , "<a class='fa fa-instagram' href='https://www.instagram.com/worldabs/' target='_blank'></a>"
                  , "<a class='fa fa-facebook' href='https://www.facebook.com/WorldABS/' target='_blank'></a>"
                  , "<a class='fa fa-search' href='/search'></a>" ]
			}]
				  
	});
  	// NAV END   ############################
  	// CART START   #########################
    $("#mmCart").mmenu({
    	offCanvas 	: {
            zposition 	: 'front',
            position 	: 'right'
        },
      
      	navbar 			: {
          	title 		: 'Shopping Cart'		
        },
		
      	navbars		: [{
			position	: 'top',
			content		: [ 'close', 'breadcrumbs' ]	
                    }]
    });
  	// CART END   ##########################
  
});
// MENUS END   #############################
